export const extendJsonLdObject = jsonLdObject => jsonLdObject;
